var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{attrs:{"id":"purchase-nav"}},[_c('ul',{staticClass:"nav nav-pills"},[_c('li',[_c('router-link',{attrs:{"to":{
        name: 'purchase_reports'
      }}},[_vm._v("\n        Purchase Reports\n      ")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{
        name: 'create_purchase'
      }}},[_vm._v("\n        New Purchase\n      ")])],1),_vm._v(" "),(_vm.purchaseId)?_c('li',[_c('router-link',{attrs:{"to":{
        name: 'edit_purchase',
        params: { purchaseId: _vm.purchaseId }
        }}},[_vm._v("\n        Edit Purchase\n      ")])],1):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4bf2a0bd","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseNav.vue
// module id = 1185
// module chunks = 1